import React from "react";

export function PinterestColored({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9998 45.8334C36.5058 45.8334 45.8332 36.506 45.8332 25.0001C45.8332 13.4941 36.5058 4.16675 24.9998 4.16675C13.4939 4.16675 4.1665 13.4941 4.1665 25.0001C4.1665 36.506 13.4939 45.8334 24.9998 45.8334Z"
        fill="#E60023"
      />
      <path
        d="M25.4623 11.8918C16.4703 11.8918 11.6963 17.9279 11.6963 24.4992C11.6963 27.5553 13.3229 31.359 15.9255 32.5705C16.3196 32.754 16.5312 32.6747 16.6218 32.2925C16.6914 32.0024 17.0424 30.5874 17.2003 29.9295C17.2507 29.7196 17.2259 29.5393 17.0561 29.3325C16.1946 28.2877 15.5056 26.3678 15.5056 24.5777C15.5056 19.9824 18.9847 15.5361 24.9118 15.5361C30.0296 15.5361 33.6129 19.0241 33.6129 24.012C33.6129 29.6474 30.7668 33.5521 27.0641 33.5521C25.0192 33.5521 23.488 31.8606 23.9791 29.7861C24.5681 27.3101 25.7051 24.6387 25.7051 22.8502C25.7051 21.2508 24.8477 19.9159 23.0697 19.9159C20.9791 19.9159 19.3004 22.0777 19.3004 24.9752C19.3004 26.8189 19.9238 28.0673 19.9238 28.0673C19.9238 28.0673 17.8589 36.7981 17.4807 38.4231C17.062 40.2171 17.2252 42.7372 17.4064 44.3849C17.8763 44.5692 18.3464 44.7534 18.8322 44.9038C19.6831 43.5206 20.952 41.252 21.4222 39.4431C21.6762 38.468 22.7211 34.4904 22.7211 34.4904C23.3998 35.7861 25.3837 36.883 27.4952 36.883C33.778 36.883 38.306 31.1049 38.306 23.9247C38.306 17.0409 32.6898 11.8918 25.4623 11.8918Z"
        fill="white"
      />
    </svg>
  );
}
